var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReport = function SvgReport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.87938 2.29588C7.47354 2.29588 6.17184 2.74142 5.10016 3.49411L14.2754 12.6693C15.028 11.5976 15.4736 10.2959 15.4736 8.89008C15.4736 5.25388 12.5156 2.29588 8.87938 2.29588ZM8.87941 15.4843C10.2846 15.4843 11.5856 15.0395 12.6567 14.2868L3.48212 5.11289C2.73009 6.18457 2.28521 7.48562 2.28521 8.89014C2.28521 12.5257 5.24321 15.4843 8.87941 15.4843ZM8.87471 17.7265C3.98557 17.7265 0.0224609 13.7634 0.0224609 8.87496C0.0224609 3.98582 3.98557 0.0227051 8.87471 0.0227051C13.7632 0.0227051 17.7263 3.98582 17.7263 8.87496C17.7263 13.7634 13.7632 17.7265 8.87471 17.7265Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/report.cc4b7a4f.svg";
export { ForwardRef as ReactComponent };